<template>
  <el-dialog :title='dialogTitle' :visible.sync='dialogVisible' :close-on-click-modal='false'
             @close='dialogClose' width='500px'>
    <el-form :model='form' label-width='130px' label-position='right' ref='ruleForm' class='mt20'>
      <el-form-item label='收单备注：'>
        <el-input v-model='form.remarks' size='mini' placeholder='请输入收单备注' />
      </el-form-item>
      <div class='flex-center-center mt20'>
        <el-button size='medium' class='searchBtn' :loading='submitLoading' @click='submit'>确认
        </el-button>
        <el-button size='medium' class='resetBtn' @click='dialogClose'>关闭</el-button>
      </div>
    </el-form>
  </el-dialog>
</template>

<script>
  import BatchImport from '@/components/batchImport';
  import { receiptProgress } from '@/service/receipt';

  export default {
    name: 'trackingProgressForm',
    components: {
      BatchImport,
    },
    data() {
      return {
        dialogVisible: false,
        dialogTitle: '跟踪进度',
        defaultForm: {},
        form: {},
        submitLoading: false,
      };
    },
    mounted() {
      this.defaultForm = JSON.parse(JSON.stringify(this.form));
    },
    methods: {
      dialogOpen(id) {
        this.form = JSON.parse(JSON.stringify(this.defaultForm));
        this.form.id = id;
        this.dialogVisible = true;
      },
      dialogClose() {
        this.dialogVisible = false;
        this.$refs.ruleForm.resetFields();
      },
      submit() {
        this.$refs.ruleForm.validate(async (valid) => {
          if (valid) {
            this.submitLoading = true;
            const {
              status,
              message,
            } = await receiptProgress(this.form);
            this.submitLoading = false;
            if (status !== 0) return this.$message.warning(message);
            this.$message.success(message);
            this.$emit('searchBtn');
            this.dialogClose();
          }
        });
      },
    },
  };
</script>

<style lang='scss' scoped></style>
